import React from 'react';
import { motion } from 'framer-motion';
import '../styles/components/_page-loader.css';

const PageLoader: React.FC = () => {
  return (
    <div className="page-loader">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="page-loader-content"
      >
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 180, 360]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="page-loader-icon"
        >
          ⚡
        </motion.div>
        
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: "100%" }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="page-loader-bar"
        />
        
        <motion.p
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{
            duration: 1.5,
            repeat: Infinity
          }}
          className="page-loader-text"
        >
          Loading...
        </motion.p>
      </motion.div>
    </div>
  );
};

export default PageLoader;
